import { useState } from "react";

export function useYearlyCycle(nodes: number = 12) {
    const [active, setActive] = useState<Set<number>>(new Set([new Date().getMonth()]));

    const trigger = (idx: number) => {
        if (idx < 0 || idx >= nodes) return;
        setActive((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(idx)) {
                newSet.delete(idx);
            } else {
                newSet.add(idx);
            }
            return newSet;
        });
    };

    return { active, trigger, nodes };
}
